import React, { FC, useState } from 'react'
import '../css/dynamicLine.css'

export interface StepItem {
  id?: number
  title?: string
  description?: string
  step?: string
}

interface DynamicLineProps{
  dataStep?: StepItem[];
}

const DynamicLine: FC<DynamicLineProps> = ({dataStep = []}) => {
  const [activeStep, setActiveStep] = useState(1)

  if (!dataStep.length) return null

  const visibleSteps =
  activeStep === dataStep.length ? dataStep.slice(1) : dataStep


  const activeIndex = visibleSteps.findIndex(
    step => step.id === activeStep
  )
  const currentStep = visibleSteps[activeIndex]

  const isShifted = activeStep === dataStep.length

  const isStart = isShifted && activeIndex === 0
  const isEnd = isShifted && activeIndex === visibleSteps.length - 1

  const maxIndex = Math.max(visibleSteps.length - 1, 1)

  let edge: 'start' | 'end' | undefined

  if (isStart) {
    edge = 'start'
  } else if (isEnd) {
    edge = 'end'
  }

  return (
    <article className="scl--dcl-art-con-bo-str">
      <div className="scl--dacbs-stl-pos">

        {/* FULL WIDTH LINE */}
        <div className="scl--dsp-stl-lin-cont" />

        {/* CONSTRAINED STEPS */}
        <div className="scl--dslc-step-inner">

          {/* Step Content */}
          <div
            className="scl--dcl-step-content"
            data-edge={edge}
            style={{
              left: `${(activeIndex / maxIndex) * 100}%`,
            }}
          >
            <h3>{currentStep.title}</h3>
            <p>{currentStep.description}</p>
          </div>

          {/* Dots */}
          <div className="scl--dacbs-step-dots">
            <div
              className={`scl--step-dots-track ${isShifted ? 'shifted' : ''
                }`}
            >
              {visibleSteps?.map((step, index) => (
                <button
                  key={step.id}
                  className={`scl--sdt-step-dot ${activeStep === step.id ? 'active' : ''
                    }`}
                  style={{
                    left: `${(index / maxIndex) * 100}%`,
                  }}
                  onClick={() => setActiveStep(step.id ?? /* istanbul ignore next */  index + 1)}
                >
                  <span className="scl--step-label">{step.step}</span>
                </button>
              ))}
            </div>
          </div>

        </div>
      </div>
    </article>

  )
}

export default DynamicLine
